import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { Fragment, useEffect } from "react";

import Login from "./components/User/login";
import { useSelector, useDispatch } from "react-redux";
import { authSelector } from "./store/selectors/index";
import { logoutAction } from "./store/actions/auth.action";
import Register from "./components/User/registerUser";
// import Example from "./components/Report/calling";
import jwt_decode from "jwt-decode";

import SaleData from "./components/saleData/saleData";
import NozelData from "./components/nozelData/nozelData.jsx";
import SaleRegister from "./components/saleRegister/report";
import TankStock from "./components/tankStock/tankStock.jsx";
import Item from "./components/item/item.jsx";
// import PdfViewer from "./components/Report/dayBookPdf/component";

function App() {
  // const { loading } = useUserContext();

  return (
    <Router>
      {/* {loading && <Loader />} */}
      <AppRoutes />
    </Router>
  );
}

function AppRoutes() {
  const { user, access_token } = useSelector(authSelector);
  const isAuth = user && access_token ? true : false;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = access_token;

    if (token) {
      const decodedToken = jwt_decode(token);
      const currentTime = Date.now() / 1000;

      // Check if token is expired
      // Set timer to log out user when token expires
      const expirationTime = decodedToken.exp - currentTime;

      setTimeout(() => {
        console.log("setTimeOut");
        dispatch(logoutAction());
        navigate("/");
      }, expirationTime * 1000);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Routes>
        {isAuth ? (
          <Fragment>
            <Route path="/registerUser" element={<Register />}></Route>
            <Route path="/nozelData" element={<NozelData />}></Route>
            <Route path="/tankData" element={<TankStock />}></Route>
            <Route path="/saleRegister" element={<SaleRegister />}></Route>
            <Route path="/saleData" element={<SaleData />}></Route>
            <Route path="/item" element={<Item />}></Route>

            <Route path="*" element={<Navigate to="/saleData" replace />} />
          </Fragment>
        ) : (
          <Fragment>
            <Route path="/" element={<Login />}></Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Fragment>
        )}
      </Routes>
    </>
  );
}

export default App;
